import React from "react";
import "./OutstationTour.css";

const destinations = [
  { name: "Hyderabad to Warangal", img: "https://www.deccanchronicle.com/h-upload/2025/05/14/1917603-ramappatemple.webp" },
  { name: "Hyderabad to Tirupati", img: "https://s7ap1.scene7.com/is/image/incredibleindia/2-sri-venkateswara-swamy-vaari-temple-2-attr-hero?qlt=82&ts=1742151008949" },
  { name: "Hyderabad to Hampi", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcShXRBpnYrGcrodlwEB2DbqYObUYMohMmKoWA&s" },
  { name: "Hyderabad to Nagarjuna Sagar", img: "https://s7ap1.scene7.com/is/image/incredibleindia/nagarjuna-sagar-dam-hyderabad-telangana-1-musthead-hero?qlt=82&ts=1742170278837" },
  { name: "Hyderabad to Srisailam", img: "https://blog.yatradham.org/wp-content/uploads/2021/07/Srisailam-Routes.jpg" },
  { name: "Hyderabad to Goa", img: "https://goavillagioresort.com/wp-content/webp-express/webp-images/uploads/2025/07/Top-Things-to-Do-Around-Near-Resort-in-South-Goa-Beaches-Culture-Food-scaled.jpg.webp" },

  { name: "Hyderabad to Vijayawada", img: "https://www.abhibus.com/blog/wp-content/uploads/2023/09/Things-to-Do-in-Vijayawada-for-a-Quick-Getaway.jpg" },
    { name: "Hyderabad to Basara", img: "https://uniquelytelangana.in/wp-content/uploads/2023/09/basara-768x450.jpg" },
    { name: "Hyderabad to Karimnagar", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcShXRBpnYrGcrodlwEB2DbqYObUYMohMmKoWA&s" },
    { name: "Hyderabad to Belum Caves", img: "https://www.deccanchronicle.com/h-upload/2025/05/14/1917603-ramappatemple.webp" },
    
];

const OutstationTour = () => {
  return (
    <div className="outstation-tour-section">
      <h2 className="outstation-heading">
        Hire <span>Tempo Traveller</span> for Your Outstation Tour
      </h2>
      <p className="outstation-description-top">
        Enjoy a comfortable, safe, and fun ride to your favorite destinations. Perfect for family trips, group tours, and sightseeing adventures.
      </p>
      <p className="outstation-description">Traveling long distances can be exhausting if your transport is not comfortable or relaxing. Long journeys can leave you tired and make it hard to enjoy your trip to the fullest. Hyderabad Tempo Travellers ensures a smooth, comfortable, and enjoyable ride for all your outstation journeys. Whether it’s Hyderabad to Warangal, Vijayawada, Tirupati, Hampi, or any nearby destination, we provide a range of luxurious and convenient travel options with our Tempo Traveller hire services.</p>
       <p className="outstation-description">Hyderabad Tempo Travellers is one of the top tempo traveller rental providers in Hyderabad for outstation trips to places like Warangal, Tirupati, Hampi, Nagarjuna Sagar, Srisailam, Goa, and more. Enjoy a royal and fun-filled trip with your friends or family. Whether it’s a cultural tour, a wildlife adventure, a hill station getaway, or a pilgrimage journey, our outstation tempo travellers ensure comfort, convenience, and safety for your group tours.</p> 


      <div className="destinations-grid">
        {destinations.map((dest, index) => (
          <div key={index} className="destination-card">
            <img src={dest.img} alt="" />
            <div className="overlay">
              {/* <h5>{dest.name}</h5> */}
              <div className="outstationTour-book-btn">{dest.name}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OutstationTour;
